import React from 'react';
import './layout/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Location from './pages/Location';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home/>}></Route>
        <Route path='/sobre-mim' element={<About/>}></Route>
        <Route path='/consultorio' element={<Location/>}></Route>
      </Routes>
    </Router>
  );
}

export default App;
